import _object_spread from "@swc/helpers/src/_object_spread.mjs";
import _object_spread_props from "@swc/helpers/src/_object_spread_props.mjs";
import _object_without_properties from "@swc/helpers/src/_object_without_properties.mjs";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from "react";
import PropTypes from "prop-types";
import theme from "~/styles/theme";
import { omitNonReactProps } from "~/services/utils";
var Twitch = function(_param) /*#__PURE__*/ {
    var fill = _param.fill, size = _param.size, otherProps = _object_without_properties(_param, [
        "fill",
        "size"
    ]);
    return _jsxs("svg", _object_spread_props(_object_spread({
        focusable: "false",
        "aria-hidden": "true",
        xmlns: "http://www.w3.org/2000/svg",
        width: size,
        height: size,
        viewBox: "0 0 24 24",
        fill: fill
    }, omitNonReactProps(otherProps)), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M19.3638 4.63428H5.86279V16.4908H9.54689V18.9416L11.9999 16.4908H16.4994L19.3638 13.6286V4.63428Z",
                fill: fill !== "#fff" ? "white" : "none"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M4.22751 3L3 6.27066V19.3517H7.49878V21.8059H9.95492L12.4086 19.3517H16.0902L21 14.4479V3H4.22751ZM5.86289 4.63429H19.3639V13.6286L16.4995 16.4908H12L9.54699 18.9416V16.4908H5.86289V4.63429ZM10.3635 12.812H12V7.90668H10.3635V12.812ZM14.8633 12.812H16.4995V7.90668H14.8633V12.812Z",
                fill: fill
            })
        ]
    }));
};
Twitch.propTypes = {
    size: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.number
    ]),
    fill: PropTypes.string
};
Twitch.defaultProps = {
    size: 24,
    fill: theme.colors.icon
};
export default Twitch;
